export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";
export const USER_LIST_RESET = "USER_LIST_RESET";

export const USER_SINGLE_REQUEST = "USER_SINGLE_REQUEST";
export const USER_SINGLE_SUCCESS = "USER_SINGLE_SUCCESS";
export const USER_SINGLE_FAIL = "USER_SINGLE_FAIL";
export const USER_SINGLE_RESET = "USER_SINGLE_RESET";

export const ME_REQUEST = "ME_REQUEST";
export const ME_SUCCESS = "ME_SUCCESS";
export const ME_FAIL = "ME_FAIL";
export const ME_RESET = "ME_RESET";

export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";
export const CREATE_USER_RESET = "CREATE_USER_RESET";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const UPDATE_USER_RESET = "UPDATE_USER_RESET";

export const RESET_USER_PASSWORD_REQUEST = "RESET_USER_PASSWORD_REQUEST";
export const RESET_USER_PASSWORD_SUCCESS = "RESET_USER_PASSWORD_SUCCESS";
export const RESET_USER_PASSWORD_FAIL = "RESET_USER_PASSWORD_FAIL";
export const RESET_USER_PASSWORD_RESET = "RESET_USER_PASSWORD_RESET";

export const ACTIVATE_DEACTIVATE_USER_REQUEST =
  "ACTIVATE_DEACTIVATE_USER_REQUEST";
export const ACTIVATE_DEACTIVATE_USER_SUCCESS =
  "ACTIVATE_DEACTIVATE_USER_SUCCESS";
export const ACTIVATE_DEACTIVATE_USER_FAIL = "ACTIVATE_DEACTIVATE_USER_FAIL";
export const ACTIVATE_DEACTIVATE_USER_RESET = "ACTIVATE_DEACTIVATE_USER_RESET";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const DELETE_USER_RESET = "DELETE_USER_RESET";
